import validate from 'mixins/validate';

export default {
  props: {
    name: String,
    label: String,
    type: {
      type: String,
      default: 'text',
    },
    modifier: {
      type: String,
      default: 'default',
    },
    autocorrect: Boolean,
    autocapitalize: Boolean,
    initialValueGetter: Function,
    placeholder: String,
    error: String,
    required: Boolean,
    validateMethod: Function,
    renderLabel: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [validate],
  data() {
    const data = {
      isValid: true,
      isActive: false,
      hasText: false,
      showErrorMessage: false,
      dirty: false,
    };

    if (
      this.initialValueGetter &&
      this.initialValueGetter.bind !== 'undefined'
    ) {
      data.inputValue = this.initialValueGetter(this.name);
    } else {
      data.inputValue = '';
    }

    return data;
  },
  watch: {
    inputValue() {
      if (!this.dirty) this.dirty = true;
      this.hasText = Boolean(this.inputValue.length);

      this.validateInput();
      this.dispatchChangeEvent();
    },
  },
  mounted() {
    this.dispatchChangeEvent();
    if (this.inputValue) this.setActive();
  },
  methods: {
    setDirty() {
      this.dirty = true;
    },
    dispatchChangeEvent() {
      this.$emit('change', {
        value: this.inputValue,
        name: this.name,
        error: this.dirty && !this.isValid,
      });
    },
    validateInput() {
      if (this.validateMethod) {
        const response = this.validateMethod({
          value: this.inputValue,
          name: this.name,
          required: this.required,
        });
        this.isValid = response.valid;
      } else if (this.required && !this.inputValue) {
        this.isValid = false;
      } else {
        this.isValid = true;
      }
      return this.isValid;
    },
    setActive() {
      this.isActive = true;
    },
    unsetActive() {
      if (!this.inputValue) this.isActive = false;
    },
    refresh() {
      setTimeout(() => {
        this.inputValue = this.$refs.input.value;
        if (this.inputValue) this.setActive();
      }, 0);
    },
  },
  template: `
  <div class="text-input" :class="['text-input--'+modifier, (!isValid)?'form-row__error': '' ]">
    <div class="text-input__wrapper">
      <label
        v-if="renderLabel"
        class="text-input__label"
        :class="{'is-active': hasText, 'has-error': dirty && !isValid }"
        :for="name"
        :id="name"
        v-text="label"
      >
      </label>
      <input
        ref="input"
        class="text-input__el p2"
        :type="type"
        :name="name"
        :autocorrect="autocorrect"
        :autocapitalize="autocapitalize"
        :placeholder="(label ? label : placeholder)"
        v-model="inputValue"
        v-on:focus="setActive && $emit('focus')"
        v-on:blur="unsetActive"
        v-on:keyup.enter="$emit('submit')"
      />
    </div>
    <transition name="fade">
      <p v-if="dirty && !isValid" class="form-row__error__text-error red">{{error}}</p>
    </transition>
  </div>`,
};
